import styled from "styled-components"

export const Ul = styled.ul`
  list-style: none;
  padding: 0;
  padding-inline-start: 0;
  margin: 0;
`

export default Ul
